import { CASES } from './constants';

const getInitialTagSort = () => {
    const saved = localStorage.getItem('tagSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

const initialState = {
    tags: [],
    tag: {},
    filterForm: {
        name: '',
    },
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    tagRange: [0, 19],
    tagSort:  getInitialTagSort(),
    defaultFilterRange: [0, 19],
    itemsPerPage: 20,
};

/**
 * Reducer function to manage the tags state in the Redux store.
 * It handles actions related to updating tags, filtering tags,
 * and clearing tags.
 *
 * @param {Object} state - The current state of the tags.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the tags after applying the action.
 **/
export function tags(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_TAGS: {
            if (payload.tagSort) {
                localStorage.setItem('tagSort', JSON.stringify(payload.tagSort));
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_TAGS_FILTER_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_TAGS: {
            return {
                ...initialState,
                tagSort: state.tagSort
            };
        }
        default:
            return state;
    }
}
